// import axios from 'axios'
import api from '../utils/api'

export const convertRDStation = (event, data) => api.post(process.env.VUE_APP_RDSTATION_CONVERT_API + event, data)

export const setWinOpportunity = (data) => {
    let VUE_APP_RDSTATION_SETOPPORTUNITY = process.env.VUE_APP_RDSTATION_SETOPPORTUNITY
    return api.post(VUE_APP_RDSTATION_SETOPPORTUNITY + 'SALE', data);
};